export function FileInputDirective(): ng.IDirective {
    return {
        scope: {
            file: '='
        },
        link: function (scope: any, element, attributes) {
            element.bind("change", function (changeEvent: any) {
                var reader = new FileReader();
                reader.onload = function (loadEvent: any) {
                    scope.$apply(function () {
                        scope.file = loadEvent.target.result;
                    });
                };
                reader.readAsDataURL(changeEvent.target.files[0]);
            });
        }
    }
}